import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Container, Paper, CircularProgress } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import toast from 'react-hot-toast'; 
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';

const ChangePasswordPage = () => {
    const { user, logout } = useAuth();
    
    const [formData, setFormData] = useState({ oldPassword: '', newPassword: '' });
    const [loading, setLoading] = useState(false);
    const [passwordError, setPasswordError] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (e.target.name === 'newPassword') {
            setPasswordError(''); 
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setPasswordError('');

        if (formData.newPassword.length < 6) {
            setPasswordError('New password must be at least 6 characters long.');
            setLoading(false);
            return;
        }

        try {
            // API Endpoint: PUT /api/users/change-password
            await api.put('/users/change-password', formData);
            
            toast.success('Password changed successfully! Logging out to apply changes.');
            setFormData({ oldPassword: '', newPassword: '' }); 
            
            setTimeout(() => {
                logout(); 
            }, 3000);

        } catch (err) {
            const message = err.response?.data?.message || 'Password change failed.';
            if (message.includes("Incorrect old password")) {
                 toast.error("Incorrect old password entered.");
            } else {
                 toast.error(message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container component="main" maxWidth="sm">
            <Paper elevation={3} sx={{ mt: 4, p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <LockIcon color="primary" sx={{ fontSize: 40, mb: 2 }} />
                <Typography component="h1" variant="h5" gutterBottom>
                    Change Your Password
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    You are logged in as: **{user?.username}**
                </Typography>

                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        label="Old Password"
                        name="oldPassword"
                        type="password"
                        value={formData.oldPassword}
                        onChange={handleChange}
                        disabled={loading}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        label="New Password (Min 6 characters)"
                        name="newPassword"
                        type="password"
                        value={formData.newPassword}
                        onChange={handleChange}
                        error={!!passwordError}
                        helperText={passwordError}
                        disabled={loading}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Change Password'}
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default ChangePasswordPage;